import React from 'react';
import Header from './components/Header';
import Home from './components/Home';
import Solucoes from './components/Solucoes';
import Clientes from './components/Clientes';
import Contato from './components/Contato';
import Monitoramento from './components/Monitoramento';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <>
      <Header />
      <Home />
      <Solucoes />
      <Clientes />
      <Contato />
      <Monitoramento />
      <Footer />
    </>
  );
}

export default App;
